/**
 * @description  Devices size
 * based on Vuetify breakpoints https://vuetifyjs.com/en/customization/breakpoints/#breakpoints
 */

export default Object.freeze({
  DESKTOP: 1264,
  TABLET: 600,
  MOBILE: 0,
})
